module.exports = __webpack_public_path__ + "img/buildings.aeaad0d3.svg";